"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _Button = _interopRequireDefault(require("../Button/Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
    showPipe = _ref.showPipe;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-btn-group flex",
    role: "group",
    "aria-label": "Button group"
  }, buttons.map(function (button, i) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: i
    }, showPipe && i % 2 === 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "separator"
    }), /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, button, {
      buttonType: button.buttonType || _constants.BUTTON_TYPES.GHOST
    })));
  }));
};
ButtonGroup.propTypes = {
  buttons: _propTypes["default"].array.isRequired,
  showPipe: _propTypes["default"].bool
};
var _default = exports["default"] = ButtonGroup;